import { canSelectAll } from './can-select-all.js';
import { SELECT_ALL_OPTION } from './select-all-option.js';

type Option = Readonly<{ value: string; label: string; disabled?: boolean }>;

/** A multi-select's rows for the current search: Select All once two or more options can be picked, then the matches, or nothing so the empty message shows. */
export function withSelectAllOption<T extends Option>(
  matches: ReadonlyArray<T>,
  options: ReadonlyArray<T>,
): Array<T | typeof SELECT_ALL_OPTION> {
  if (matches.length === 0) return [];
  return canSelectAll(options) ? [SELECT_ALL_OPTION, ...matches] : [...matches];
}
